// Generated by Melange

import * as Subsonic__Utils from "./utils.jsx";

function make(credentials, id) {
  const params = {};
  params["id"] = {
    TAG: /* Value */ 1,
    _0: id
  };
  return Subsonic__Utils.buildSubsonicApiUrl(credentials, {
    _method: "rest/stream",
    params: params
  }).href;
}

export {
  make,
}
/* No side effect */
